import cn from 'classnames'
import styles from './field.module.scss'

/**
 * Labeled form-field wrapper. The actual input/textarea/select is passed as
 * children so callers stay in control of the element they need.
 *
 * @param {{
 *   label: string,
 *   htmlFor: string,
 *   required?: boolean,
 *   error?: string|null,
 *   hint?: string,
 *   className?: string,
 *   children: React.ReactNode
 * }} props
 */
export function Field({label, htmlFor, required = false, error, className, children}) {
    const errorId = error ? `${htmlFor}-error` : undefined

    return (
        <div className={cn(styles.field, {[styles.invalid]: !!error}, className)}>
            <label htmlFor={htmlFor} className={styles.label}>
                {label}
                {required && <span className={styles.required} aria-hidden="true"> *</span>}
            </label>
            <div className={styles.control}>{children}</div>
            {!!error && (
                <p id={errorId} className={styles.error} role="alert">{error}</p>
            )}
        </div>
    )
}
